import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var newsCard = /*#__PURE__*/css("width:320px;min-width:320px;white-space:normal;", media('>=tablet'), "{width:100%;}");